<template lang="pug">
  #inicio-amenaza
    .container-fluid
      .row
        .title.mx-auto.d-flex
          img(src="/assets/img/microsite/Amenaza.png")
      .row.content.d-flex
        .col-md-6
          img.blue-fig(src="/assets/img/microsite/ovalfig.png")
          img.covid(src="/assets/img/microsite/COVID_STRUCTURE_1.png")
        .col-12.col-sm-10.col-md-6.text.px-4.d-flex
          p.sub-title.neutral-text.mb-0 Todo lo que debes saber
          p.sub-title.accent-yellow-text.bold Sobre el coronavirus
          p.subtext.neutral-text ¿Qué es un virus y cómo nos afecta? ¿Qué son los coronavirus? ¿Cómo es el COVID19 distinto de la influenza? Te explicamos lo más esencial sobre el virus que está paralizando el mundo.
          router-link.story-btn(to="/sobre-coronavirus#intro") Ver Storytelling
</template>
<script>
export default {
  name: "Section1"
};
</script>

<style lang="scss">
#inicio-amenaza {
  min-height: 100vh;
  padding: 1rem 0;
  margin-bottom: 10rem;
  .title {
    justify-content: center;
    align-items: center;
    img {
      width: 30vw;
      max-width: 350px;
    }
  }
  .content {
    min-height: 85vh;
    background-image: url("/assets/img/microsite/Oval_Micrositio1.png");
    background-size: 100% 100%;
    //text-align: center;
    justify-content: center;
    align-items: center;
    .blue-fig {
      max-height: 45vh;
      margin: auto 0 0 -1rem;
      max-width: 30%;
    }
    .covid {
      margin: 0 0 0 1rem;
      width: 60%;
      //max-width: 500px;
      text-align: right;
    }
    .text {
      flex-direction: column;
      text-align: center;
      justify-content: center;
      align-items: center;
      line-height: 1;
      .subtext {
        line-height: 1.75;
      }
      a {
        color: #fff;
      }
      .story-btn {
        font-family: "Oswald", sans-serif;
        border: solid 3px #57c2ca;
        border-radius: 45px;
        font-size: 1.2rem;
        padding: 0.5rem 2.5rem;
        margin: 2rem auto;
      }
      .story-btn:hover {
        background-color: #57c2ca;
      }
    }
  }
}
// Small devices
@media (max-width: 500px) {
  #inicio-amenaza {
    .title {
      img {
        width: auto;
        max-width: 225px;
      }
    }
    .sub-title {
      font-size: 1.7rem;
    }
    .content {
      min-height: 0;
      background-image: url("/assets/img/microsite/Oval_Micrositio1_Mobile.png");
      padding: 2rem 0;
      .blue-fig {
        max-height: 40vh;
        max-width: 20vw;
      }
      .covid {
        width: 60vw;
        max-width: 460px;
      }
      .text {
        .subtext {
          font-size: 0.8rem;
          line-height: 1.5;
          max-width: 80%;
        }
        .story-btn {
          font-family: "Oswald", sans-serif;
          border: solid 2px #57c2ca;
          border-radius: 35px;
          font-size: 1rem;
          padding: 0.5rem 2rem;
          margin: 1rem auto 2rem auto;
        }
      }
    }
  }
}
</style>
